/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IHospital } from 'app/shared/model/hospital.model';

export interface IShift {
  id?: string;
  name?: string | null;
  code?: string | null;
  from?: number | null;
  to?: number | null;
  length?: number | null;
  hasBonus?: boolean | null;
  active?: boolean | null;
  cursor?: number | null;
  lastUpdate?: number | null;
  microSec?: number | null;
  timestampEntry?: number | null;
  hospital?: IHospital | null;
}

export const defaultValue: Readonly<IShift> = {
  hasBonus: false,
  active: false,
};
